// routes
import { PATH_MY_ACCOUNT } from '../../../routes/paths';
// components
import Iconify from '../../../components/iconify';

const navConfig = [
  {
    subheader: 'general',
    items: [
      { title: 'Mi cuenta', path: PATH_MY_ACCOUNT.account, icon: <Iconify icon="duo-icons:user" width={16} /> },
      { title: 'Mis compras', path: PATH_MY_ACCOUNT.purchased.list, icon: <Iconify icon="ic:twotone-shopping-cart" width={16} /> },
    ],
  },
];

export default navConfig;
